import React, {useState, useEffect, Fragment} from 'react'
import flatstore from 'flatstore';
import { useLocation } from 'react-router-dom';
import Loader from '../../../components/ui/Loader';
import LoadModules from '../../../components/ui/LoadModules'
import {getStaticSync} from '../../../utils/services';
import Meta from '../../../components/ui/Meta';
import {replace, isNil} from 'lodash';
import { currentLang } from '../../../utils/functions';
import NotFound from '../404';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

function Statics({static_data, loading, err_data}) {
    const [data, setData] = useState(null);
    const [modules, setModules] = useState(null);
    const { t } = useTranslation();
    //console.log(11);
    let location = useLocation();
    let urlpaths = replace(location.pathname, '/'+currentLang()+'/', '').split('/');
    
    let slug = urlpaths[0];
    if(urlpaths[1] && (urlpaths[1] == t("menu.animal")) && urlpaths[2]){
        var filter = urlpaths[2];
    }
    
    useEffect(() => {
        //console.log(slug, data, static_data);
        if(static_data && slug != static_data.slug){
            static_data = null;
            setData(null);
        }
    }, [location.pathname])

    useEffect(() => {
        //console.log(static_data, data);
		if (isNil(static_data)) {
            getStaticSync(slug, 'static_data');
        }
        if(static_data && isNil(data)){
            setData(static_data);
        }
        
		if(static_data && static_data.modules !== null){
            setModules(static_data.modules);
        }
        
    }, [static_data, location.pathname]);

    useEffect(() => {
        //console.log(err_data);
    }, [err_data])
    
    if (loading) {
		return <Loader />
	} else {
        return (
            <Fragment>
                {modules &&
                    <LoadModules modules={modules} filter={filter} type="top" />
                }
                {err_data && err_data == '404' &&
                    <NotFound />
                }
                {data &&
                    <Meta
                        title={data.seo_title ? data.seo_title : data.title}
                        description={data.seo_description ? data.seo_description : data.body}
                    />
                 }
                {data && data.body &&
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-xxl-6 offset-xxl-3 col-lg-8 offset-lg-2 mb-40 mt-40">
                                <h1 className="heading--h1">{data.title}</h1>
                                <div className="page__body">{parse(data.body)}</div>
                            </div>
                        </div>
                    </div>
                }
                {modules &&
                    <LoadModules modules={modules} filter={filter} type="bottom" />
                }
          
            </Fragment>
        )
    }
}

export default flatstore.connect(['loading', 'static_data', 'err_data'])(Statics);
